import { Injectable } from "@angular/core";
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { UserProfileStore } from "../stores/user-profile.store";
import { AuthService } from "../providers/auth.service";
import { NotificationService } from "../providers/notification.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		private readonly authenticationService: AuthService,
		private readonly notificationService: NotificationService,
		private readonly _userProfileStore: UserProfileStore,
		private readonly _translateService: TranslateService,
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((err) => {
				if (err.url && err.url.includes("graph.microsoft")) {
					const error =
						(err && err.error && err.error.message) ||
						err.statusText;
					return throwError(error);
				}

				if (
					[401, 403].includes(err.status) &&
					this._userProfileStore.getUserProfile()
				) {
					// auto logout if 401 or 403 response returned from api
					this.notificationService.showError(
						this._translateService.instant(
							"shared.errorAuthentication",
						) + err.status,
					);
					//this.authenticationService.logOut();
				} else if ([0].includes(err.status)) {
					// auto logout if 401 or 403 response returned from api
					this.notificationService.showError(
						this._translateService.instant("shared.errorApi") +
							err.status,
					);
				} else if (err.status) {
					this.notificationService.showError(
						this._translateService.instant("shared.errorUnknown") +
							err.status,
					);
				}

				const error =
					(err && err.error && err.error.message) || err.statusText;
				return throwError(error);
			}),
		);
	}
}
